namespace GeniuzPOS.InventoryReport {
    export interface IcReport05Form {
    }

    export class IcReport05Form extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReport05';
    }
}
